<div [ngClass]="'panel ' + color">
    <div class="panel-heading">
        <h5 style="display: inline-block">
            <span>Mine Sites </span>
            <span class="badge badge-info">{{ minesites.length }}</span>
        </h5>
        <div class="btn-toolbar pull-right">
            <div class="btn-group btn-group-md" *ngIf="!live">
                <button type="button" class="btn btn-primary" title="Add Mine Site"(click)="addMinesite()">
                    <span data-toggle="tooltip" class="fa fa-plus-square fa-lg"></span>
                </button>
            </div>
            <div class="btn-group btn-group-md">
                <minesite-filter [live]="live"></minesite-filter>
            </div>
        </div>
    </div>
    <div class="panel-body panel-list">
        <div *ngIf="processing" class="list-group" style="overflow-y:scroll; max-height: 600px;">
            <i class="fa fa-spinner fa-spin"></i> Loading Minesites...
        </div>
        <div class="panel-group" style="height:370px" *ngIf="!processing">
            <minesite-entity [live]="live" [attr.data-minesite-id]="minesite.Minesite_ID" [minesite]="minesite" [full]="true" *ngFor="let minesite of minesites"></minesite-entity>
        </div>
    </div>
</div>

<div bsModal #minesiteDetails="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog" style="width: 1000px;">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="close()" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h3 class="modal-title" id="myModalLabel">{{ minesite.Name }} &bull; Details</h3>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="pull-right">
                            <span>Date Last Modified </span>
                            <i class="fa fa-ellipsis-v"></i>
                            <span> {{ minesite.LastModified | amDateFormat: 'MM/DD/YYYY' }} at {{ minesite.LastModified | amDateFormat: 'hh:mm A' }}</span>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="pull-right">
                            <span>Status </span>
                            <i class="fa fa-ellipsis-v"></i>
                            <span> {{ minesite.Active ? 'Active' : 'Inactive' }}</span>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-lg-6" style="height: 180px;" data-bind="with: companies = $data.Companies">
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                <h4>
                                    <span>Company Operation</span>
                                    <span class="pull-right badge">{{ companies.length }}</span>
                                </h4>
                            </div>
                            <div class="panel-body" style="height: 120px; overflow-y: scroll;">
                                <table style="width: 100%">
                                    <colgroup>
                                        <col style="width: 50%" />
                                        <col style="width: 50%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Company</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let company of companies">
                                            <td>{{ company.Name }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6" style="height: 180px;">
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                <h4>
                                    <span>Equipment</span>
                                    <span class="pull-right badge">{{ equipment.length }}</span>
                                </h4>
                            </div>
                            <div class="panel-body" style="height: 120px; overflow-y: scroll;">
                                <table style="width: 100%">
                                    <colgroup>
                                        <col style="width: 50%" />
                                        <col style="width: 50%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>Serial Number</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let eq of equipment">
                                            <td>
                                                {{ eq.Serial }} ({{ eq.Model.Name }} {{eq.PoweredBy.Name }})
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-lg-12" style="height: 180px;">
                        <div class="panel panel-info">
                            <div class="panel-heading">
                                <h4>
                                    <span>Associated Accounts</span>
                                    <span class="pull-right badge">{{ users.length }}</span>
                                </h4>
                            </div>
                            <div class="panel-body" style="height: 120px; overflow-y: scroll;" data-bind="foreach: Users()">
                                <div class="well well-sm col-lg-3" *ngFor="let user of users">
                                    <span>{{ user.FirstName }} {{ user.LastName }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="close()">Close</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!live" bsModal #createMinesiteModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <form (ngSubmit)="create()" #createMinesiteForm="ngForm">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="cancelAdd()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">{{ add ? 'Create Minesite' : 'Edit Minesite &bull;' + minesite.Name }}</h4>
                </div>
                <div class="modal-body" data-bind="with: entity">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback" data-bind="validationElement: Name">
                                <label class="control-group input-group-addon" for="MinesiteName">Mine Site Name</label>
                                <input #minesiteNameControl="ngModel" name="MinesiteName" type="text" class="form-control" placeholder="Mine Site Name" required [(ngModel)]="minesite.Name" [ngClass]="{ 'has-error' : !minesiteNameControl.valid }" />
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="!add">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback">
                                <label class="control-group input-group-addon">Status</label>
                                <div class="btn-group btn-group-justified">
                                    <label class="btn" [class.btn-info]="minesite.Active" [class.btn-warning]="!minesite.Active" (click)="minesite.Active = !minesite.Active">
                                        <span>{{ minesite.Active ? 'Active' : 'Inactive' }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" *ngIf="add" class="pull-left btn btn-default" [disabled]="!createMinesiteForm.form.valid" (click)="create(true)">Create and Add Another</button>
                    <button type="button" class="btn btn-default" (click)="cancelAdd()">Close</button>
                    <button type="submit" class="btn btn-primary" [disabled]="!createMinesiteForm.form.valid">{{ add ? 'Create' : 'Save' }}</button>
                </div>
            </form>
        </div>
    </div>
</div>